
import { initOurBrandsCountries } from "./../js/ourBrandsCountries/initOurBrandsCountries";

initOurBrandsCountries('js-countries-list');
